<template>
  <div v-if="!hideScrollbar" class="footer-wrapper">
    <div class="footer-svg" :class="{ dark }" />
    <div class="footer-content d-flex align-items-center justify-content-center flex-column" :class="{ isXmas }">
      <div class="sns d-flex">
        <a class="mr-3" href="https://www.tumblr.com/blog/characterhub-com" target="_blank"
          ><i class="ti-tumblr-alt"
        /></a>
        <a class="mr-3" href="https://twitter.com/characterhub" target="_blank"><i class="ti-twitter-alt" /></a>
        <a class="mr-3" href="https://www.instagram.com/characterhub/" target="_blank"><i class="ti-instagram" /></a>
        <a class="mr-3" href="https://www.facebook.com/characterhub" target="_blank"><i class="ti-facebook" /></a>
        <a
          class="mr-3 d-flex align-items-center justify-content-center tiktok-link"
          href="https://www.tiktok.com/@character.hub"
          target="_blank"
        >
          <inline-svg class="footer-tiktok" src="/icons/tiktok.svg" width="22px" height="26px" />
        </a>
        <a href="https://www.youtube.com/@characterhub" target="_blank"><i class="ti-youtube" /></a>
      </div>
      <div class="pages">
        <router-link to="/terms">Terms</router-link>
        |
        <router-link to="/privacy">Privacy</router-link>
        |
        <router-link to="/cookies">Cookies</router-link>
        |
        <router-link to="/dmca">DMCA</router-link>
        |
        <a href="https://characterhub.com/blog" target="_blank">Blog</a>
      </div>
      <div class="credits mt-1">© 2023 UsePencil, Inc. All Rights Reserved.&nbsp;Ver 1.0{{ appVer }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-property-decorator';
import { featureFlags } from '@/config/feature-flags';
import { mainStore } from '~/pinia-store/main';
import { useWindowSize } from '~/composition/useWindowSize';

@Options({
  name: 'Footer',
  components: {},
})
export default class Footer extends Vue {
  public get routeName() {
    try {
      const router = useRouter();
      return router.currentRoute.value.name;
    } catch (error) {
      return '';
    }
  }

  public get isChatPage() {
    return this.routeName === 'social-space-chatroom';
  }

  public get menuOpenOnSmallViewPort() {
    try {
      if (!window) return false;

      const { menuCollapsed } = mainStore();
      const { width } = useWindowSize();

      return !menuCollapsed.value && width.value <= 1320;
    } catch (error) {
      return false;
    }
  }

  public get hideScrollbar() {
    return this.isChatPage || this.menuOpenOnSmallViewPort;
  }

  public isXmas = featureFlags.isXmas;

  public get dark() {
    const { dark } = mainStore();
    return dark.value;
  }

  public get appVer() {
    try {
      const {
        public: { buildNumber },
      } = useRuntimeConfig();
      return buildNumber || 0;
    } catch (error) {
      return 0;
    }
  }
}
</script>

<style scoped lang="sass">
@media(max-width: 570px)
  .footer-content, .footer-svg, .footer-cover
    display: none !important
@media(min-width: 460px)
  .footer-cover
    &:not(.dark)
      display: none
@media(max-width: 460px)
  .footer-svg
    min-width: 110%
    left: 0
    bottom: 40px !important
@media(min-width: 600px)
  .footer-svg
    &:not(.dark)
      background-position-y: calc(100% + 30px)
@media(min-width: 860px)
  .footer-svg
    &:not(.dark)
      background-position-y: calc(100% + 50px)
@media(min-width: 1000px)
  .footer-svg
    &:not(.dark)
      background-position-y: calc(100% + 50px)
@media(min-width: 1200px)
  .footer-svg
    &:not(.dark)
      background-position-y: calc(100% + 50px)

.footer-svg
  position: absolute
  bottom: -5px
  right: 0
  width: 100%
  pointer-events: none
  z-index: 1
  // background-image: url(/footer.svg)
  height: 1000px
  background-size: 100%
  background-position-y: 100%
  background-repeat: no-repeat
  &.dark
    background-image: url(/footer-dark.svg)
    background-position-y: 100%
    bottom: 70px
.footer-content
  z-index: 1
  height: 70px
  min-height: 70px
  font-size: 11px
  width: 100%
  position: relative
  *
    color: var(--ion-color-primary)
  &.isXmas
    background: transparent
.sns
  font-size: 22px
.tiktok-link
  width: 22px
  height: 26px
  margin-top: -2px
.footer-tiktok
  ::v-deep
    path
      fill: #ae38e5
</style>
